import React, { useMemo } from 'react';
import type { ReactElement } from 'react';
import classnames from 'classnames';
import { Table } from 'antd';
import type { TableProps } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import Top1Svg from 'assets/Top1_big.svg';
import Top2Svg from 'assets/Top2_big.svg';
import Top3Svg from 'assets/Top3_big.svg';
import styles from './index.module.scss';

export type PintoTableProps<RecordType> = {
  showOrder?: boolean;
  orderColumnWidth?: number;
} & TableProps<RecordType>;

const PintoTable: <RecordType>(props: PintoTableProps<RecordType>) => ReactElement<any, any> | null = ({
  showOrder,
  orderColumnWidth = 42,
  ...props
}) => {
  const { columns } = props;
  const formattedColumns = useMemo(
    () =>
      showOrder
        ? [
            {
              width: orderColumnWidth,
              align: 'center',
              render(_, __, index: number) {
                switch (index) {
                  case 0:
                    return <Top1Svg viewBox="0 0 48 47" className={classnames(styles.orderIcon, 'icon')} />;
                  case 1:
                    return <Top2Svg viewBox="0 0 48 47" className={classnames(styles.orderIcon, 'icon')} />;
                  case 2:
                    return <Top3Svg viewBox="0 0 48 47" className={classnames(styles.orderIcon, 'icon')} />;
                  default:
                    return <span className={styles.order}>{index + 1}</span>;
                }
              },
            },
          ].concat(columns as any[])
        : columns,
    [columns, orderColumnWidth, showOrder]
  );
  const rowClassName = (_, index) => {
    return index % 2 ? styles.evenRow : styles.oddRow;
  };
  return (
    <Table
      {...props}
      className={classnames(styles.table, props.className)}
      rowClassName={rowClassName}
      columns={formattedColumns as ColumnsType}
    />
  );
};

export default PintoTable;
